/* eslint-disable max-len */

export const requiredRegex = /\S+/;

/*
    Password must contain at least one uppercase letter, one lowercase letter, and one number or special character.
    The spec for special characters is taken from here https://owasp.org/www-community/password-special-characters
*/
export const passwordComplexityRegex =
    /^(?=.*?[A-Z])(?=.*?[a-z])(?=.*?[0-9])(?=.*?[ !"#$%&'()*+,-./:;<=>?@[\]^_`{|}~]).+$/;

/*
    should check emails according to RFC-2822
    https://www.rfc-editor.org/rfc/rfc2822#section-3.4.1
*/
export const validEmailRegex =
    /[a-zA-Z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-zA-Z0-9!#$%&'*+/=?^_`{|}~-]+)*@(?:[a-zA-Z0-9](?:[a-zA-Z0-9-]*[a-zA-Z0-9])?\.)+[a-zA-Z0-9](?:[a-zA-Z0-9-]*[a-zA-Z0-9])?/;

export const whiteSpaceMatcherRegex = /\s/;

export const emailIsValid = (emailValue: string) =>
    validEmailRegex.test(emailValue) && !whiteSpaceMatcherRegex.test(emailValue);

export const loginPasswordRules = {
    required: {
        value: true,
        message: 'Password is required',
    },
};
